import cn from '@pkgs/shared-client/helpers/cn';

type Props = {
	className?: string;
};

const SVNewBadge = ({ className }: Props) => (
	<span
		className={cn(
			cn(
				'from-brand to-brand-2 type-small relative ml-2 inline-block rounded bg-gradient-to-r from-50% px-[7px] py-[5px] text-[10px] font-medium leading-none text-white',
			),
			className,
		)}
	>
		NEW
	</span>
);

export default SVNewBadge;
